import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Blog from "../Blog/Blog";
import Aboutus from "../Blog/Pages/Aboutus";
import Contacts from "../Blog/Pages/Contacts";

import Services from "../Blog/Pages/Services/Services";

import UseScrollToTop from "../../UseScrollToTop";
import Header from "../Blog/Header/Header";
import Footer from "../Blog/Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";

import Doctors from "../Blog/Pages/doctors/Doctors";
import Departments from "../Blog/Pages/departments/Departments";
// import HealthPackagesPage from "../Blog/healthpackages/HealthPackagesPage";
import BookAppointment from "../Blog/Pages/bookappointment/BookAppointment";
import BookAppointmentsDoctors from "../Blog/Pages/bookappointment/BookAppointmentsDoctors";
import ImageGallery from "../Blog/Pages/gallery/ImageGallery";
import ImageGalleryStatic from "../Blog/Pages/gallery/ImageGalleryStatic";
import BlogPage from "../Blog/Pages/blogpage/BlogPage";
import HealthPackagesPage from "../Blog/Pages/healthpackages/HealthPackagesPage";
import Dialysis from "../Blog/Pages/dialysis/Dialysis";
import News from "../Blog/Pages/news/News";
import InternationalDesk from "../Blog/Pages/internationalDesk/InternationalDesk";
import DialysisMarquee from "../Blog/Pages/DialysisMArquee";
import Insurances from "../Blog/Pages/insurances/Insurances";
function Rootstock() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate a delay to show the preloader
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 1 seconds

    // Clear the timer when component unmounts
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 3000, // Animation duration in milliseconds
      once: true, // Animation will happen only once while scrolling down
    });
  }, []);

  return (
    <Router>
      <UseScrollToTop />
      <Header />
      <DialysisMarquee/>
      <Routes>
        <Route path="/" element={<Blog />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/doctors" element={<Doctors />} />

        <Route path="/services" element={<Services />} />
        <Route path="/departments" element={<Departments />} />
        <Route path="/lab-dialysis" element={<Dialysis />} />
        <Route path="/latest-news" element={<News />} />
        <Route path="/health-packages" element={<HealthPackagesPage />} />
        <Route path="/book-appointment" element={<BookAppointment />} />
        <Route
          path="/bookappointments/:doctorId"
          element={<BookAppointmentsDoctors />}
        />
        {/* <Route path="/gallery" element={<ImageGallery />} /> */}
        <Route path="/gallery" element={<ImageGalleryStatic />} />
        <Route path="/contacts" element={<Contacts />} />
        <Route path="/our-blogs" element={<BlogPage />} />
        <Route path="/international-patient-desk" element={<InternationalDesk />} />
        <Route path="/insurances" element={<Insurances />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default Rootstock;
